import { Component, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { QnSbnDataServiceService } from '../../services/qn-sbn-data-service.service';
import { OneWebComponentsAngularModule } from '@one/angular';
import { FileUploadSingleComponent } from '../file-upload/file-upload-single/file-upload-single.component';
import { CommonModule } from '@angular/common';
import { AppUtils } from '../../utlis/app-utils';
import { snackbarService } from '@one/web-components';

@Component({
  selector: 'dl-notification-doc',
  standalone: true,
  imports:[OneWebComponentsAngularModule,ReactiveFormsModule,FileUploadSingleComponent,CommonModule,FormsModule],
  templateUrl: './notification-doc.component.html',
  styleUrl: './notification-doc.component.scss',
  providers: [AppUtils],
})
export class NotificationDocComponent {

  // @ViewChild(MatSort, { static: true }) public sort: MatSort;
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(FileUploadSingleComponent)
  private singleFileUploadComp: FileUploadSingleComponent;
  public fileData = [];
  public columnData: any;
  // public dataSource = new MatTableDataSource(ELEMENT_DATA);
  // public selection = new SelectionModel(true, []);
  public ELEMENT_DATA: any[] = []; // Use a simple array for data
  public selectedFiles: any[] = []; 
  public selectedRow: any; 
  public notificationTypeFormControl= new FormControl('');
  public userFileSize = { size: 0, type: '' };
  public notificationTypeList = [
    {
      label: 'SBN',
      value: 'Safety Board Notification',
      disabled: false
    },
    {
      label: 'QN',
      value: 'Quality Notification',
      disabled: false
    },
    {
      label: 'MN',
      value: 'Marketting Notification',
      disabled: false
    },
    {
      label: 'SN',
      value: 'Support Notification',
      disabled: false
    },
    {
      label: 'SNR',
      value: 'Support Notification with Risk',
      disabled: false
    }
  ];
  isTableShow: boolean = false;
  selectedData;
  count = 0;
  public documentEnabled: boolean;

  public constructor(public appUtil: AppUtils,private qnsbnService: QnSbnService,private _QnSbnDataService:QnSbnDataServiceService) {
     this._QnSbnDataService.DocumentEnabled$.subscribe(
      res =>{
        this.documentEnabled = res;
      } 
    )
    // this.iconRegistry.addSvgIconLiteral('no_data_found', this.sanitizer.bypassSecurityTrustHtml(NO_DATA_FOUND_ICON));
  }
 
  public isDocumentAdded = true;
  public filesList = [];
  public files = [];
  public searchedItem = [];
  public allDraftData = {};
  public searchDocumentControl = new FormControl();
  public dataFlag: boolean = false;
  private isUpdatingDoc = false;
  public ngOnInit() {
    this._QnSbnDataService.mappingData$.subscribe(observer=>{
      if(this.isUpdatingDoc) return;
      if(!this._QnSbnDataService.isEmpty(observer['notificationDoc'])) {
        this.addSearchedDocument(observer['notificationDoc']);
        this.allDraftData = observer['notificationRowData'];
      }
      
      // this.dataTobestore = observer;
    })
  }

  ngAfterViewInit(): void {  
    // this.dataSource.paginator = this.paginator;
  }
  public addSearchedDocument(rowData: any,checkFromDelete?): void {
    this.selectedData = rowData;
    this.isTableShow = false;
    this.files.length = 0;
    const fileName = rowData['Title'] || rowData['FileName'] || '';
    const fileExt = rowData['FileExtension'] || (fileName.includes('.') ? fileName.split('.').pop() : '');
    const fileProperties = {
      name: fileName,
      size: rowData['FileSize'] || 0,
      fileIcon: fileExt === 'pdf' ? 'file_pdf' : 'file_word'
    };
    this.files.push(fileProperties);
    this.isDocumentAdded = true;
    this.searchDocumentControl.setValue('');
    this.notificationTypeFormControl.setValue('');
    this.addProduct(this.selectedData);
    checkFromDelete ? this.snackBarMessage('positive', 'Notification document successfully added') : false;

    return;
  }
 
  onSearch() {
    let checkDocType = this.notificationTypeFormControl.value || '';
    let url = this.searchDocumentControl.value + "&documenttype=" + checkDocType;
  
    this.qnsbnService.notificationDocPiosDocSearch(url).subscribe({
      next: (d) => {
        this.files.length = 0;
        this.ELEMENT_DATA = d; // Assign the response to ELEMENT_DATA
      
        
        // Check if the data is an array
        this.dataFlag = Array.isArray(this.ELEMENT_DATA);
        this.isTableShow = true; // Show the table
        this.ngAfterViewInit(); // Trigger any necessary lifecycle updates
        if (this.singleFileUploadComp) {
          this.singleFileUploadComp.filesSingle.length = 0;
        }
        this.searchDocumentControl.setValue('');
        this.notificationTypeFormControl.setValue('');
      },
      error: (error) => {
        this.files.length = 0;
        this.ELEMENT_DATA = []; // Reset ELEMENT_DATA on error
        this.dataFlag = Array.isArray(this.ELEMENT_DATA);
        this.isTableShow = true;
        this.ngAfterViewInit();
        if (this.singleFileUploadComp) {
          this.singleFileUploadComp.filesSingle.length = 0;
        }
        this.searchDocumentControl.setValue('');
        this.notificationTypeFormControl.setValue('');
        this.qnsbnService.httpErrorHandler(error, 'Please Select Notification Type');
      },
    });
  }
  
  public addProduct(newData) {
    // console.log('New Data to be added:', newData); // Debug log to check the data being passed
    this.isUpdatingDoc = true;
    this._QnSbnDataService.getMappedQnsbnData(newData,"NotificationDoc");
    this.isUpdatingDoc = false;
    return;
 }

  public deleteFile(i, file) {
    this.files = this.files.filter(item => item !== file);
    const message = file.name + ' notification document successfully deleted';
    this.snackBarMessage('positive', message);
    if(this.files.length < 1){
      this.selectedData = '';
      this.addProduct(this.selectedData);
    }
  }

  public downloadDocument(fileName: string) {
    const isSavedFile = this.verifyGlobalDocument(fileName);
    if(isSavedFile) {
      const notificationDoc = this.allDraftData['NotificationDocuments'][0];
      if(notificationDoc.PIMID) {
        this.qnsbnService.downloadPiosDocumentApi(notificationDoc.PIMID, notificationDoc.FileExtension);
      } else {
        // Local file saved as notification document
        const notificationId = this.allDraftData['NotificationId'] || '';
        this.qnsbnService.downloadLocalAttachmentApi(fileName, notificationId);
      }
    } else {
      const notificationDocNew = this.selectedData;
      if(notificationDocNew?.PIMID) {
        this.qnsbnService.downloadPiosDocumentApi(notificationDocNew.PIMID, notificationDocNew.FileExtension);
      } else {
        this.snackBarMessage('alarm', 'File not yet saved. Please save the notification first.');
      }
    }  
  }

  public verifyGlobalDocument(fileName: string): boolean {
    const uploadedFiles = this.allDraftData['NotificationDocuments'] || [];
    const isSavedFile = uploadedFiles.some(fileItem => (fileItem.Title === fileName || fileItem.FileName === fileName));
    return isSavedFile;
  }

  ngOnDestroy(): void {
  }

  public bytesCalculation(bytes: number, decimals: number = 2): any {
    if (bytes === 0) {
      this.userFileSize.size = 0;
      this.userFileSize.type = '';
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    this.userFileSize.size = 0;
    this.userFileSize.type = '';

    this.userFileSize.size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    this.userFileSize.type = sizes[i];
    return this.userFileSize;
  }

  public formatBytes(bytes: number, decimals: number = 2): string {
    if (!bytes || bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    return size + ' ' + sizes[i];
  }

  public updateDocumentEnabled(toggle){
    this._QnSbnDataService.setDocumentToggle(toggle);
    if(!toggle) {
      // Clear selected document data when disabled
      this.selectedData = '';
      this.files = [];
      this.addProduct({});
    }
  }

  snackBarMessage(status:any,message:string){
      snackbarService.show({
        message: message, 
        snackbarProps: {
          status: status,
          direction: 'horizontal',
          showClose: true,
          elevated: false,
          duration: 5000,
          verticalPlacement: 'top',
          horizontalPlacement: 'right',
        }
      });
    }

}let ELEMENT_DATA = [];
